<!-- 地图 -->
<template>
	<div class="mapArea map-grid div_map">
		<!-- 高德地图 -->
		<div id="container"></div>
		<!-- iframe嵌套 -->
		<!-- <iframe id="gaodeMap" v-if="isMobile" :src="mobileMap" allowfullscreen=""></iframe>
		<iframe id="gaodeMap" v-else :src="pcMap" allowfullscreen=""></iframe> -->
	</div>
</template>

<script>
	export default {
		name: "Map",
		data() {
			return {
				// 高德开放平台key
				MapKey: "2743c4ecb7e07938ecfb00a9f7e71355",
				// 经度
				lng: 116.181677,
				// 纬度
				lat: 39.731657,
				// 地图对象
				map: {},
				// 地图拖拽
				positionPicker: {},
				// 标记
				marker: {},
				// 弹框信息
				infoWindow: {},

				//用来判断是否是移动端设备的,条件成立代表的是移动端的设备
				isMobile: /AppleWebKit.*Mobile/i.test(navigator.userAgent) || (
					/MIDP|SymbianOS|NOKIA|SAMSUNG|LG|NEC|TCL|Alcatel|BIRD|DBTEL|Dopod|PHILIPS|HAIER|LENOVO|MOT-|Nokia|SonyEricsson|SIE-|Amoi|ZTE/
					.test(navigator.userAgent)),
				//高德地图
				mobileMap: "https://m.amap.com/search/mapview/keywords=%E6%98%AD%E5%90%9B(%E5%8C%97%E4%BA%AC)%E7%9F%A5%E8%AF%86%E4%BA%A7%E6%9D%83%E4%BB%A3%E7%90%86%E6%9C%89%E9%99%90%E5%85%AC%E5%8F%B8&city=110111&poiid=B0FFJCSM06",
				pcMap: "https://www.amap.com/search?id=B0FFJCSM06&city=110111&geoobj=116.308125%7C39.843334%7C116.612308%7C39.971851&query_type=IDQ&query=%E6%98%AD%E5%90%9B(%E5%8C%97%E4%BA%AC)%E7%9F%A5%E8%AF%86%E4%BA%A7%E6%9D%83%E4%BB%A3%E7%90%86%E6%9C%89%E9%99%90%E5%85%AC%E5%8F%B8&zoom=12"
			}
		},
		// 引入高德地图jdk
		async created() {
			// 已载入高德地图API，则直接初始化地图
			if (window.AMap && window.AMapUI) {
				this.initMap()
				// 未载入高德地图API，则先载入API再初始化
			} else {
				await this.remoteLoad(`http://webapi.amap.com/maps?v=1.4.15&key=${this.MapKey}`)
				await this.remoteLoad('http://webapi.amap.com/ui/1.0/main.js')
				this.initMap()
			}
		},
		mounted() {
			// 关闭事件
			window.clickEvent = this.close;
		},
		methods: {
			// 动态加载js
			remoteLoad(url) {
				return new Promise(function(resolve, reject) {
					let script = document.createElement('script')
					script.type = 'text/javascript';
					// IE
					if (script.readyState) {
						script.onreadystatechange = function() {
							if (script.readyState == 'loaded' ||
								script.readyState == 'complete') {
								script.onreadystatechange = null;
								resolve();
							}
						};
					} else {
						// 其他浏览器
						script.onload = function() {
							resolve();
						};
					}
					script.charset = 'utf-8';
					script.src = url;
					document.head.appendChild(script);
				})
			},
			// 初始化地图
			initMap() {
				// 加载PositionPicker，loadUI的路径参数为模块名中 'ui/' 之后的部分
				let AMapUI = this.AMapUI = window.AMapUI
				let AMap = this.AMap = window.AMap
				AMapUI.loadUI(['misc/PositionPicker'], PositionPicker => {
					this.map = new AMap.Map('container', {
						// 开启缩放
						resizeEnable: true,
						// 缩放级别
						zoom: 15,
						// 中心位置经纬度
						center: [this.lng, this.lat]
					})
					// 加载地图搜索插件
					AMap.service('AMap.PlaceSearch', () => {
						this.placeSearch = new AMap.PlaceSearch({
							pageSize: 5,
							pageIndex: 1,
							citylimit: true,
							city: "北京",
							map: this.map,
							panel: 'js-result'
						})
					})
					// 启用工具条
					AMap.plugin(['AMap.ToolBar'], () => {
						this.map.addControl(new AMap.ToolBar({
							position: 'RB'
						}))
					})
					// 地图拖拽
					this.positionPicker = new PositionPicker({
						mode: 'dragMap', // 设定为拖拽地图模式，可选'dragMap'、'dragMarker'，默认为'dragMap'
						map: this.map // 依赖地图对象
					})
					// 添加marker标记
					this.addMarker()
				})
			},
			// 添加marker标记
			addMarker() {
				this.map.clearMap();
				this.marker = new AMap.Marker({
					map: this.map,
					// 标记点位置
					position: [this.lng, this.lat]
				});
				// 设置弹框内容
				this.setInfoWindow()

				//鼠标点击marker弹出自定义的信息窗体
				AMap.event.addListener(this.marker, 'click', this.setInfoWindow);
			},
			// 设置弹框内容
			setInfoWindow() {
				this.infoWindow = new AMap.InfoWindow({
					isCustom: true, //使用自定义窗体
					content: `<div class="custom-info input-card content-window-card">
						<div class="info-top">
							<div>昭君(北京)知识产权代理有限公司</div>
							<img src="https://webapi.amap.com/images/close2.gif" onclick="clickEvent()">
						</div>
						<div class="info-middle">
							<div><img src="${require('../assets/images/common/logo.png')}"></div>
							<div>
								地址：北京市房山区卓秀北街8号院8号楼9层911
								</br>
								电话：18519164916
							</div>
						</div>
						<div class="info-bottom">
							<img src="https://webapi.amap.com/images/sharp.png">
						</div>
					</div>`,
					offset: new AMap.Pixel(16, -45)
				});
				this.infoWindow.open(this.map, this.marker.getPosition());
			},
			// 关闭弹框
			close() {
				this.map.clearInfoWindow()
			}
		}
	}
</script>

<style>
	.div_map iframe {
		height: 40rem !important;
	}

	#container {
		width: 100%;
		height: 600px;
	}

	.content-window-card {
		position: relative;
		box-shadow: none;
		bottom: 0;
		left: 0;
		width: auto;
		padding: 0;
	}

	.content-window-card p {
		height: 2rem;
	}

	.custom-info {
		border: solid 1px silver;
	}

	div.info-top {
		position: relative;
		background: none repeat scroll 0 0 #F9F9F9;
		border-bottom: 1px solid #CCC;
		border-radius: 5px 5px 0 0;
	}

	div.info-top div {
		display: inline-block;
		color: #333333;
		font-size: 14px;
		font-weight: bold;
		line-height: 31px;
		padding: 0 10px;
	}

	div.info-top img {
		cursor: pointer;
		position: absolute;
		top: 10px;
		right: 10px;
		transition-duration: 0.25s;
		width: 12px;
	}

	div.info-top img:hover {
		box-shadow: 0px 0px 5px #000;
	}

	div.info-middle {
		background: #fff;
		color: #333;
		font-size: 14px;
		padding: 10px 6px;
		line-height: 24px;
	}

	div.info-bottom {
		height: 0px;
		width: 100%;
		clear: both;
		text-align: center;
	}

	div.info-bottom img {
		position: relative;
		z-index: 104;
	}

	span {
		margin-left: 5px;
		font-size: 11px;
	}

	.info-middle img {
		float: left;
		margin-right: 6px;
		height: 80px;
	}
</style>
